export default __webpack_public_path__ + "static/media/icon_texturas.416e9747.svg";